var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FCFC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5769L13.7089 10C15.4227 8.40289 16.9309 6.68898 18 5C15.9855 5.87337 13.9263 7.13327 12 8.5769Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7845 11.9628L10.9104 9.98141C9.3201 8.44799 8.27327 7.86202 6.55628 7C7.3809 8.87868 7.96826 10.0458 9.44995 11.7794C8.21352 13.1532 7.09776 14.5817 6.17766 15.9613C5.75256 16.6189 5.34348 17.2808 5 18C5.68773 17.6606 6.32372 17.2492 6.95658 16.8208C8.29045 15.8881 9.67744 14.7471 11.0168 13.4752C12.2505 14.7128 13.004 15.2221 14.2668 16.0883C14.8257 16.4591 15.3873 16.8118 16 17.0939C15.7372 16.4406 15.408 15.8417 15.0615 15.2454C14.2908 13.9618 13.8753 13.2243 12.7845 11.9628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.1aee0c3f3cb868a5d7e6382e54be9b50.svg";
export { ForwardRef as ReactComponent };